import React, { Component } from 'react';
import ReactExport from "react-export-excel-xlsx-fix";
import { ImportExport } from "@mui/icons-material";
import moment from "moment";
import Global from "../../customlib/Global";
import { Button } from '@mui/material';

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;
class ExportTeleDiChatCustomer extends Component {

    getleadsReportData = () => {
        let leadsData = [];
        this.props.leadsReportData.forEach(element => {
            element.leads.forEach(lead => {
                lead.maskedFrom = Global.maskPhoneNumber(lead.from);
                lead.formattedCreatedAt = Global.formatDateTimeToStrDateTime24(lead.created_at);
                leadsData.push(lead);
            });
        });
        return leadsData;
    }

    getSummaryReportData = () => {
        console.log("LEADSDATA1", this.props.leadsReportData);
        let leadsData = [];
        this.props.leadsReportData.forEach(element => {
            leadsData.push(element);
        });
        return leadsData;
    }

    state = {  }
    render() { 
        return (
            <ExcelFile element={<Button variant='contained' color='primary'><ImportExport />Export ke Excel</Button>}>
            {/* <ExcelFile> */}
                <ExcelSheet data={this.getSummaryReportData} name="Summary Leads Tele Di Chat">
                    <ExcelColumn label="Sales" value="salesName"/>
                    <ExcelColumn label="Avg Respon" value="avgResponseTime"/>
                    <ExcelColumn label="Jumlah Customer" value="leadsCount"/>
                    <ExcelColumn label="Closing" value="closingCountTotal"/>
                    <ExcelColumn label="Pending" value="pendingCountTotal"/>
                    <ExcelColumn label="Konfirmasi" value="konfirmasiCountTotal"/>
                    <ExcelColumn label="Cancel" value="cancelCountTotal"/>
                    <ExcelColumn label="Kurang dari 1 Menit" value="under1Minute"/>
                    <ExcelColumn label="Lebih dari 1 Menit" value="upper1Minute"/>
                </ExcelSheet>
                <ExcelSheet data={this.getleadsReportData} name="Leads Tele Di Chat">
                    <ExcelColumn label="Sales" value="assignToUserName"/>
                    <ExcelColumn label="Customer" value="fromName"/>
                    <ExcelColumn label="WhatsApp Number" value="maskedFrom"/>
                    <ExcelColumn label="Label" value="label"/>
                    <ExcelColumn label="Tgl Chat Masuk"
                                  value={(col) => Global.formatDateTimeToStrDateTime24(col.created_at)}/> 
                    <ExcelColumn label="Response"
                                  value={(col) => Global.formatTime(col.avgResponseTime)}/> 
                </ExcelSheet>
            </ExcelFile>
        );
    }
}
 
export default ExportTeleDiChatCustomer;